<template>
  <div>
    <form
      class="form form-horizontal"
      role="form"
      @submit.prevent="saveUser"
      id="ma-form"
      name="myForm"
      novalidate
    >
      <modal :width="width">
        <div slot="header">
          <button type="button" class="close" @click="CloseModal">
            &times;
          </button>
          <h2 class="modal-title">{{ title == null ? Vendor : title }}</h2>
        </div>
        <div slot="body">
          <div v-if="success_message != '' && success_message != null">
            <div class="alert alert-success text-center">
              <strong>{{ success_message }}</strong>
            </div>
          </div>
          <div v-if="User_message != null && User_message != ''">
            <div class="alert alert-danger text-center">
              <strong>{{ User_message }}</strong>
            </div>
          </div>
          <div v-if="errorMessage != null && errorMessage != ''">
            <div class="alert alert-danger text-center">
              <strong>{{ errorMessage }}</strong>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-4">
              <label>
                Name
                <span class="text-danger">*</span>
              </label>

              <input
                type="text"
                class="form-control"
                name="Name"
                placeholder="Name"
                autocomplete="off"
                maxlength="250"
                v-model="Name"
                data-vv-validate-on="blur"
                v-validate="'required|alpha_spaces|max:250'"
                :class="{
                  'input-validation-error':
                    (NameFlags.invalid && !NameFlags.pristine) ||
                    errors.has('Name'),
                }"
              />
              <span class="text-danger">{{ errors.first("Name") }}</span>
            </div>
            <div class="col-xs-4">
              <label>
                User Name
                <span class="text-danger">*</span>
              </label>

              <input
                type="text"
                class="form-control"
                :class="{
                  'input-validation-error':
                    (UsernameFlags.invalid && !UsernameFlags.pristine) ||
                    errors.has('Username'),
                }"
                v-model="UserName"
                data-vv-validate-on="blur"
                name="Username"
                autocomplete="off"
                maxlength="250"
                placeholder="User Name"
                data-vv-as="User Name"
                v-validate="
                  'required|min:5|Alpha_number_under|max:250|username-validate'
                "
                required
              />
              <span class="text-danger">{{ errors.first("Username") }}</span>
            </div>
            <div class="col-xs-4">
              <label>
                Email
                <span class="text-danger">*</span>
              </label>

              <input
                type="email"
                class="form-control"
                :class="{
                  'input-validation-error':
                    (EmailFlags.invalid && !EmailFlags.pristine) ||
                    errors.has('Email'),
                }"
                name="Email"
                v-validate="'required|min:5|email|email-validate|max:250'"
                maxlength="250"
                placeholder="Email"
                autocomplete="off"
                v-model="Email"
                data-vv-validate-on="blur"
                required
              />
              <span class="text-danger">{{ errors.first("Email") }}</span>
            </div>
          </div>

          <div class="form-group">
            <div class="col-xs-4" v-if="SavePassword">
              <label>
                Password
                <span class="text-danger">*</span>
              </label>
              <input
                type="password"
                class="form-control"
                :class="{
                  'input-validation-error':
                    (PasswordFlags.invalid && !PasswordFlags.pristine) ||
                    errors.has('Password'),
                }"
                name="Password"
                placeholder="Password"
                v-model="Password"
                maxlength="250"
                autocomplete="off"
                ref="pass"
                v-validate="'required|min:8|strong_password'"
                data-vv-validate-on="blur"
              />
              <span class="text-danger">{{ errors.first("Password") }}</span>
            </div>
            <div class="col-xs-4" v-if="SavePassword">
              <label>
                Confirm Password
                <span class="text-danger">*</span>
              </label>
              <input
                type="password"
                class="form-control"
                v-validate="'required|confirmed:pass'"
                :class="{
                  'input-validation-error':
                    (ConfirmPasswordFlags.invalid &&
                      !ConfirmPasswordFlags.pristine) ||
                    errors.has('ConfirmPassword'),
                }"
                name="ConfirmPassword"
                placeholder="Confirm Password"
                data-vv-validate-on="blur"
                v-model="ConfirmPassword"
                data-vv-as="Confirm Password"
                required
              />
              <span class="text-danger">{{
                errors.first("ConfirmPassword")
              }}</span>
            </div>
            <div class="col-xs-4">
              <label>
                Role
                <span class="text-danger">*</span>
              </label>
              <select
                class="form-control input-sm"
                name="Roles"
                data-vv-as="Roles"
                v-model="Roles"
                v-validate="'required'"
                :class="{
                  'input-validation-error':
                    (RolesFlags.invalid && !RolesFlags.pristine) ||
                    errors.has('Roles'),
                }"
              >
                <option
                  v-for="(option, index) in UserRoles"
                  :value="option.Id"
                  :key="index"
                >
                  {{ option.Name }}
                </option>
              </select>
              <span class="text-danger">{{ errors.first("Roles") }}</span>
            </div>
            <div v-if="!SavePassword">
              <div class="col-xs-6" v-if="Roles == 3 || Roles == 4">
                <!-- <label>
                  Departments
                  <span class="text-danger">*</span>
                </label>
                <select
                  class="form-control input-sm"
                  name="DepartmentId"
                  v-model="Department"
                  :class="{'input-validation-error': ((DepartmentIdFlags.invalid && !DepartmentIdFlags.pristine)||errors.has('DepartmentId'))}"
                >
                  <option style="font-size:15;" value>SELECT DEPARTMENT</option>
                  <option
                    v-for="(option,index) in departments"
                    :value="option.id"
                    :key="index"
                  >{{option.name}}</option>
                </select>-->
                <label>
                  Departments
                  <span class="text-danger">*</span>
                </label>

                <multiselect
                  v-model="UsersSelectedDepartMent"
                  tag-placeholder="Select Departments"
                  placeholder="Select Departments"
                  label="Name"
                  track-by="Id"
                  :hide-selected="true"
                  data-vv-rules="required"
                  :options="departments"
                  :multiple="true"
                  :taggable="true"
                ></multiselect>

                <span class="text-danger">{{
                  errors.first("DepartmentId")
                }}</span>
              </div>
            </div>
          </div>

          <div class="form-group" v-if="SavePassword">
            <!-- </div> -->
            <!-- <div class="form-group"> -->
            <div class="col-xs-8" v-if="Roles == 3 || Roles == 4">
              <label>
                Departments
                <span class="text-danger">*</span>
              </label>

              <multiselect
                v-model="UsersSelectedDepartMent"
                tag-placeholder="Select Departments"
                placeholder="Select Departments"
                label="Name"
                track-by="Id"
                :hide-selected="true"
                data-vv-rules="required"
                :options="departments"
                :multiple="true"
                :taggable="true"
                open-direction="bottom"
                id="ajax"
              ></multiselect>

              <!-- 
              <select
                class="form-control input-sm"
                name="DepartmentId"
                v-model="Department"
                :class="{'input-validation-error': ((DepartmentIdFlags.invalid && !DepartmentIdFlags.pristine)||errors.has('DepartmentId'))}"
              >
                <option style="font-size:15;" value>SELECT DEPARTMENT</option>
                <option
                  v-for="(option,index) in departments"
                  :value="option.id"
                  :key="index"
                >{{option.name}}</option>
              </select>-->
              <span class="text-danger">{{
                errors.first("DepartmentId")
              }}</span>
            </div>
          </div>

          <div class="form-group">
            <div class="col-xs-4">
              <label for="deleted">Deleted</label>
              <br />
              <input type="checkbox" id="deleted" v-model="Deleted" />
              <div>
                <strong v-currentdate></strong>
              </div>
            </div>
            <div class="col-xs-4" v-if="UserId">
              <label for="deleted">Change Password</label>
              <br />
              <input type="checkbox" id="SavePassword" v-model="SavePassword" />
              <div>
                <strong v-currentdate></strong>
              </div>
            </div>
            <div class="col-xs-4" v-if="UserId">
              <label for="deleted">Blocked</label>
              <br />
              <input type="checkbox" id="Blocked" v-model="Blocked" />
              <div></div>
            </div>
          </div>
        </div>

        <div slot="footer">
          <span class="pull-left text-danger">*Mandatory fields</span>
          <loading v-if="loading"></loading>
          <input type="submit" class="btn btn-primary" value="Save" />
          <button class="btn btn-warning" @click="CloseModal">Cancel</button>
        </div>
      </modal>
    </form>
  </div>
</template>

<script>
const dict = {
  custom: {
    ConfirmPassword: {
      confirmed: "Password does not Match",
      // required: 'Your email is empty'
    },
    Name: {
      alpha_spaces: "The Name field may only contain alphabetic characters.",
    },
  },
};

import { mapFields } from "vee-validate";
import * as ACTIONS from "../../store/actions";
import { mapGetters, mapState } from "vuex";
import VeeValidate, { Validator } from "vee-validate";
import Multiselect from "vue-multiselect";

Validator.localize("en", dict);

export default {
  data() {
    return {
      title: "Add User",
      width: 800,
      User_message: null,
      success_message: null,
      // user: {
      Email: null,
      Name: null,
      UserName: null,
      UsersSelectedDepartMent: [],
      //departments: null,
      Password: null,
      ConfirmPassword: null,
      selectdeRole: null,
      Roles: null,
      Deleted: false,
      Department: null,
      SavePassword: true,
      Blocked: false,
      //  }
    };
  },
  components: { Multiselect },
  props: { UserId: Number },
  methods: {
    CloseModal() {
      this.$emit("Close");
    },
    saveUser() {
      var valid = true;
      if (this.Roles == undefined || this.Roles == "") {
        valid = false;
        this.$validator.validateAll();
        this.$validator.errors.add({
          field: "Roles",
          msg: "Please Select Role",
        });
      }

      if (
        (this.Roles == 3 || this.Roles == 4) &&
        (this.UsersSelectedDepartMent == null ||
          this.UsersSelectedDepartMent.length == 0)
      ) {
        valid = false;
        this.$validator.validateAll();
        this.$validator.errors.add({
          field: "DepartmentId",
          msg: "Please Select Department",
        });
      }
      if (valid) {
        var vm = this;
        this.User_message = "";
        this.success_message = "";
        this.$validator.errors.remove("DepartmentId");
        if (this.SavePassword != true) {
          this.$validator.errors.remove("Password");
          this.$validator.errors.remove("ConfirmPassword");
          this.Password = "";
          this.ConfirmPassword = "";
        }

        this.$validator.validateAll().then((result) => {
          if (result) {
            var params = new URLSearchParams();
            params.append("Name", vm.Name);
            params.append("Email", vm.Email);
            params.append("Username", vm.UserName);

            params.append("RoleId", vm.Roles);
            params.append("Password", vm.Password);
            params.append("ConfirmPassword", vm.ConfirmPassword);
            params.append("Deleted", vm.Deleted == false ? 0 : 1);
            params.append("Id", vm.UserId == null ? 0 : vm.UserId);
            params.append(
              "SavePassword",
              vm.SavePassword == true ? true : false
            );
            params.append("Blocked", vm.Blocked == true ? true : false);
            for (var i = 0; i < vm.UsersSelectedDepartMent.length; i++) {
              params.append(
                "UserDepartment[" + i + "].Id",
                vm.UsersSelectedDepartMent[i].Id
              );
              // params.append("UserDepartment["+this.UsersSelectedDepartMent[i].id+"].Id",this.UsersSelectedDepartMent.id);
              //params.append("+this.UsersSelectedDepartMent[i].id+"]Id",this.UsersSelectedDepartMent.id);
            }
            params.append(
              "DepartmentId",
              vm.Department == null ? 0 : vm.Department
            );

            this.$store
              .dispatch(ACTIONS.USERS_SAVE, params)
              .then((res) => {
                var { data } = res;
                if (data && data.StatusCode == 200) {
                  vm.Password = "";
                  vm.ConfirmPassword = "";
                  //vm.success_message = "Vendor Added Successfully";
                  if (vm.UserId) {
                    vm.success_message = "User modified Successfully";
                  } else {
                    vm.success_message = "User saved Successfully";
                  }
                  setTimeout(function () {
                    vm.success_message = null;
                    vm.CloseModal();
                  }, 1500);
                } else if (data && data.StatusCode == 450) {
                  var { ResponseData } = data;
                  if (ResponseData) {
                    for (var prop in ResponseData) {
                      vm.$validator.errors.add({
                        field: prop,
                        msg: ResponseData[prop],
                      });
                    }
                  }
                }
              })
              .catch((err) => {});
          } else {
            vm.User_message = "Please provide correct details.";
            setTimeout(function () {
              vm.User_message = null;
            }, 1800);
          }
        });
      }
    },
    getRoles() {
      this.$store
        .dispatch(ACTIONS.USERS_GET_ROLES)
        .then((res) => {})
        .catch((err) => {});
    },
    getDepartments() {
      this.$store
        .dispatch(ACTIONS.USERS_GET_DEPARTMENTS)
        .then((res) => {})
        .catch((err) => {});
    },
    getData() {
      var vm = this;
      this.$store
        .dispatch(ACTIONS.USERS_GET, this.UserId)
        .then((res) => {
          var { data } = res;
          if (data && data.StatusCode == 200) {
            var { user } = data.ResponseData;
            vm.Email = user.Email;
            vm.Name = user.Name;
            vm.Roles = user.RoleId;
            vm.UserName = user.Username;
            vm.Department = user.DepartmentId;
            vm.Deleted = user.Deleted == 1 ? true : false;
            vm.UsersSelectedDepartMent = data.ResponseData.UserDepartment;

            vm.Blocked = user.Blocked;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  beforeMount() {
    if (this.UserId) {
      this.getData();
    } else {
      this.getDepartments();
      //this.getRoles();
    }
  },
  computed: {
    ...mapGetters({
      errorMessage: "GETUSERSAVEERRORMESSAGE",
      loading: "GETUSERSAVELOADING",
      UserRoles: "GETUSERROLES",
      departments: "GETDEPARTMENTS",
    }),
    ...mapFields({
      NameFlags: "Name",
      EmailFlags: "Email",
      UsernameFlags: "Username",
      PasswordFlags: "Passowrd",
      ConfirmPasswordFlags: "ConfirmPassword",
      RolesFlags: "Roles",
      DepartmentIdFlags: "DepartmentId",
    }),
  },
  created() {
    var vm = this;
    VeeValidate.Validator.extend("email-validate", {
      validate: function (value, obj) {
        if (value) {
          //var Senddata = {id:0, value: value}
          var Senddata = { id: vm.UserId, value: value };
          return vm.$store
            .dispatch(ACTIONS.USERS_CHECK_DUPLICATE_EMAIL, Senddata)
            .then((res) => {
              return { valid: res.data };
            })
            .catch((err) => {
              return { valid: true };
            });
        }
      },
      getMessage: function (field, params, value) {
        return "Duplicate email";
      },
    });

    VeeValidate.Validator.extend("username-validate", {
      validate: function (value, obj) {
        if (value) {
          //var Senddata = {id:0, value: value}
          var Senddata = { id: vm.UserId, value: value };
          return vm.$store
            .dispatch(ACTIONS.USERS_CHECK_DUPLICATE_USERNAME, Senddata)
            .then((res) => {
              return { valid: res.data };
            })
            .catch((err) => {
              return { valid: true };
            });
        }
      },
      getMessage: function (field, params, value) {
        return "Duplicate User Name";
      },
    });

    VeeValidate.Validator.extend("name-validate", {
      validate: function (value, obj) {
        if (value) {
          //var Senddata = {id:0, value: value}
          var Senddata = { id: vm.UserId, value: value };
          return vm.$store
            .dispatch(ACTIONS.USERS_CHECK_DUPLICATE_NAME, Senddata)
            .then((res) => {
              return { valid: res.data };
            })
            .catch((err) => {
              return { valid: true };
            });
        }
      },
      getMessage: function (field, params, value) {
        return "Duplicate Name";
      },
    });
  },
};
</script>

<style>
@import url(https://fonts.googleapis.com/css?family=Lato:700,400);
@import url(https://fonts.googleapis.com/css?family=Dosis:400);
fieldset[disabled] .multiselect {
  pointer-events: none;
}
.multiselect__spinner {
  position: absolute;
  right: 1px;
  top: 1px;
  width: 48px;
  height: 35px;
  background: #fff;
  display: block;
}
.multiselect__spinner:after,
.multiselect__spinner:before {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  margin: -8px 0 0 -8px;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  border-color: #41b883 transparent transparent;
  border-style: solid;
  border-width: 2px;
  box-shadow: 0 0 0 1px transparent;
}
.multiselect__spinner:before {
  animation: a 2.4s cubic-bezier(0.41, 0.26, 0.2, 0.62);
  animation-iteration-count: infinite;
}
.multiselect__spinner:after {
  animation: a 2.4s cubic-bezier(0.51, 0.09, 0.21, 0.8);
  animation-iteration-count: infinite;
}
.multiselect__loading-enter-active,
.multiselect__loading-leave-active {
  transition: opacity 0.4s ease-in-out;
  opacity: 1;
}
.multiselect__loading-enter,
.multiselect__loading-leave-active {
  opacity: 0;
}
.multiselect,
.multiselect__input,
.multiselect__single {
  font-family: inherit;
  font-size: 14px;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
}
.multiselect {
  box-sizing: content-box;
  display: block;
  position: relative;
  width: 100%;
  min-height: 40px;
  text-align: left;
  color: #35495e;
}
.multiselect * {
  box-sizing: border-box;
}
.multiselect:focus {
  outline: none;
}
.multiselect--disabled {
  background: #ededed;
  pointer-events: none;
  opacity: 0.6;
}
.multiselect--active {
  z-index: 3;
}
.multiselect--active:not(.multiselect--above) .multiselect__current,
.multiselect--active:not(.multiselect--above) .multiselect__input,
.multiselect--active:not(.multiselect--above) .multiselect__tags {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.multiselect--active .multiselect__select {
  transform: rotate(180deg);
}
.multiselect--above.multiselect--active .multiselect__current,
.multiselect--above.multiselect--active .multiselect__input,
.multiselect--above.multiselect--active .multiselect__tags {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.multiselect__input,
.multiselect__single {
  position: relative;
  display: inline-block;
  min-height: 20px;
  line-height: 20px;
  border: none;
  border-radius: 5px;
  background: #fff;
  padding: 0 0 0 5px;
  width: 100%;
  transition: border 0.1s ease;
  box-sizing: border-box;
  margin-bottom: 8px;
  vertical-align: top;
}
.multiselect__input:-ms-input-placeholder {
  color: #35495e;
}
.multiselect__input::placeholder {
  color: #35495e;
}
.multiselect__tag ~ .multiselect__input,
.multiselect__tag ~ .multiselect__single {
  width: auto;
}
.multiselect__input:hover,
.multiselect__single:hover {
  border-color: #cfcfcf;
}
.multiselect__input:focus,
.multiselect__single:focus {
  border-color: #a8a8a8;
  outline: none;
}
.multiselect__single {
  padding-left: 5px;
  margin-bottom: 8px;
}
.multiselect__tags-wrap {
  display: inline;
}
.multiselect__tags {
  min-height: 40px;
  display: block;
  padding: 8px 40px 0 8px;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  font-size: 14px;
}
.multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #41b883;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
}
.multiselect__tag-icon {
  cursor: pointer;
  margin-left: 7px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  font-weight: 700;
  font-style: normal;
  width: 22px;
  text-align: center;
  line-height: 22px;
  transition: all 0.2s ease;
  border-radius: 5px;
}
.multiselect__tag-icon:after {
  content: "\D7";
  color: #266d4d;
  font-size: 14px;
}
.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #369a6e;
}
.multiselect__tag-icon:focus:after,
.multiselect__tag-icon:hover:after {
  color: #fff;
}
.multiselect__current {
  min-height: 40px;
  overflow: hidden;
  padding: 8px 12px 0;
  padding-right: 30px;
  white-space: nowrap;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
}
.multiselect__current,
.multiselect__select {
  line-height: 16px;
  box-sizing: border-box;
  display: block;
  margin: 0;
  text-decoration: none;
  cursor: pointer;
}
.multiselect__select {
  position: absolute;
  width: 40px;
  height: 38px;
  right: 1px;
  top: 1px;
  padding: 4px 8px;
  text-align: center;
  transition: transform 0.2s ease;
}
.multiselect__select:before {
  position: relative;
  right: 0;
  top: 65%;
  color: #999;
  margin-top: 4px;
  border-style: solid;
  border-width: 5px 5px 0;
  border-color: #999 transparent transparent;
  content: "";
}
.multiselect__placeholder {
  color: #adadad;
  display: inline-block;
  margin-bottom: 10px;
  padding-top: 2px;
}
.multiselect--active .multiselect__placeholder {
  display: none;
}
.multiselect__content-wrapper {
  position: absolute;
  display: block;
  background: #fff;
  width: 100%;
  max-height: 240px;
  overflow: auto;
  border: 1px solid #e8e8e8;
  border-top: none;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  z-index: 3;
  -webkit-overflow-scrolling: touch;
}
.multiselect__content {
  list-style: none;
  display: inline-block;
  padding: 0;
  margin: 0;
  min-width: 100%;
  vertical-align: top;
}
.multiselect--above .multiselect__content-wrapper {
  bottom: 100%;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom: none;
  border-top: 1px solid #e8e8e8;
}
.multiselect__content::webkit-scrollbar {
  display: none;
}
.multiselect__element {
  display: block;
}
.multiselect__option {
  display: block;
  padding: 12px;
  min-height: 40px;
  line-height: 16px;
  text-decoration: none;
  text-transform: none;
  vertical-align: middle;
  position: relative;
  cursor: pointer;
  white-space: nowrap;
}
.multiselect__option:after {
  top: 0;
  right: 0;
  position: absolute;
  line-height: 40px;
  padding-right: 12px;
  padding-left: 20px;
  font-size: 13px;
}
.multiselect__option--highlight {
  background: #41b883;
  outline: none;
  color: #fff;
}
.multiselect__option--highlight:after {
  content: attr(data-select);
  background: #41b883;
  color: #fff;
}
.multiselect__option--selected {
  background: #f3f3f3;
  color: #35495e;
  font-weight: 700;
}
.multiselect__option--selected:after {
  content: attr(data-selected);
  color: silver;
}
.multiselect__option--selected.multiselect__option--highlight {
  background: #ff6a6a;
  color: #fff;
}
.multiselect__option--selected.multiselect__option--highlight:after {
  background: #ff6a6a;
  content: attr(data-deselect);
  color: #fff;
}
.multiselect--disabled .multiselect__current,
.multiselect--disabled .multiselect__select {
  background: #ededed;
  color: #a6a6a6;
}
.multiselect__option--disabled {
  background: #ededed !important;
  color: #a6a6a6 !important;
  cursor: text;
  pointer-events: none;
}
.multiselect__option--group {
  background: #ededed;
  color: #35495e;
}
.multiselect__option--group.multiselect__option--highlight {
  background: #35495e;
  color: #fff;
}
.multiselect__option--group.multiselect__option--highlight:after {
  background: #35495e;
}
.multiselect__option--disabled.multiselect__option--highlight {
  background: #dedede;
}
.multiselect__option--group-selected.multiselect__option--highlight {
  background: #ff6a6a;
  color: #fff;
}
.multiselect__option--group-selected.multiselect__option--highlight:after {
  background: #ff6a6a;
  content: attr(data-deselect);
  color: #fff;
}
.multiselect-enter-active,
.multiselect-leave-active {
  transition: all 0.15s ease;
}
.multiselect-enter,
.multiselect-leave-active {
  opacity: 0;
}
.multiselect__strong {
  margin-bottom: 8px;
  line-height: 20px;
  display: inline-block;
  vertical-align: top;
}
[dir="rtl"] .multiselect {
  text-align: right;
}
[dir="rtl"] .multiselect__select {
  right: auto;
  left: 1px;
}
[dir="rtl"] .multiselect__tags {
  padding: 8px 8px 0 40px;
}
[dir="rtl"] .multiselect__content {
  text-align: right;
}
[dir="rtl"] .multiselect__option:after {
  right: auto;
  left: 0;
}
[dir="rtl"] .multiselect__clear {
  right: auto;
  left: 12px;
}
[dir="rtl"] .multiselect__spinner {
  right: auto;
  left: 1px;
}
.custom__tag {
  display: inline-block;
  padding: 3px 12px;
  background: #d2d7ff;
  margin-right: 8px;
  margin-bottom: 8px;
  border-radius: 10px;
  cursor: pointer;
}
.custom__tag:nth-child(2n) {
  background: #daffee;
}
.custom__tag:hover {
  background: #eaeaea;
}
.custom__remove {
  padding: 0;
  font-size: 10px;
  margin-left: 5px;
}
.multiselect__clear {
  position: absolute;
  right: 41px;
  height: 40px;
  width: 40px;
  display: block;
  cursor: pointer;
  z-index: 2;
}
.multiselect__clear:after,
.multiselect__clear:before {
  content: "";
  display: block;
  position: absolute;
  width: 3px;
  height: 16px;
  background: #aaa;
  top: 12px;
  right: 4px;
}
.multiselect__clear:before {
  transform: rotate(45deg);
}
.multiselect__clear:after {
  transform: rotate(-45deg);
}
.option__image {
  max-height: 80px;
  margin-right: 10px;
}
.option__desc,
.option__image {
  display: inline-block;
  vertical-align: middle;
}
.option__desc {
  padding: rem(10px);
}
.option__title {
  font-size: rem(24px);
}
.option__small {
  margin-top: rem(10px);
  display: block;
}
.form__label {
  margin-top: 5px !important;
}
.badge__img {
  vertical-align: middle;
  float: right;
}
.badge__name {
  vertical-align: middle;
  display: inline-block;
  margin-left: 5px;
  float: left;
}
/*! normalize.css v3.0.2 | MIT License | git.io/normalize */
html {
  font-family: sans-serif;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}
body {
  margin: 0;
}
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary {
  display: block;
}
audio,
canvas,
progress,
video {
  display: inline-block;
  vertical-align: baseline;
}
audio:not([controls]) {
  display: none;
  height: 0;
}
[hidden],
template {
  display: none;
}
a {
  background-color: transparent;
}
a:active,
a:hover {
  outline: 0;
}
abbr[title] {
  border-bottom: 1px dotted;
}
dfn {
  font-style: italic;
}
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}
mark {
  background: #ff0;
  color: #000;
}
small {
  font-size: 80%;
}
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sup {
  top: -0.5em;
}
sub {
  bottom: -0.25em;
}
img {
  border: 0;
}
svg:not(:root) {
  overflow: hidden;
}
figure {
  margin: 1em 40px;
}
hr {
  box-sizing: content-box;
  height: 0;
}
pre {
  overflow: auto;
}
code,
kbd,
pre,
samp {
  font-family: monospace, monospace;
  font-size: 1em;
}
button,
input,
optgroup,
select,
textarea {
  color: inherit;
  font: inherit;
  margin: 0;
}
button {
  overflow: visible;
}
button,
select {
  text-transform: none;
}
button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
}
button[disabled],
html input[disabled] {
  cursor: default;
}
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}
input {
  line-height: normal;
}
input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  height: auto;
}
input[type="search"] {
  -webkit-appearance: textfield;
  box-sizing: content-box;
}
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}
fieldset {
  border: 1px solid silver;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}
legend {
  border: 0;
  padding: 0;
}
textarea {
  overflow: auto;
}
optgroup {
  font-weight: 700;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
td,
th {
  padding: 0;
}
@keyframes a {
  0% {
    transform: rotate(0);
  }
  to {
    transform: rotate(2turn);
  }
}
body {
  color: #374853;
  font-size: 16px;
}
::selection {
  background: #41b883;
  color: #fff;
}
.typo__h1,
.typo__h2,
.typo__h3,
.typo__h4,
.typo__h5 {
  margin-top: 0;
  margin-bottom: 1rem;
  color: #374853;
  line-height: 1.2;
}
.typo__h1 {
  font-family: Dosis, sans-serif;
  font-weight: 700;
  font-size: 1rem;
  margin: 0.625rem 0 2.5rem;
}
@media only screen and (min-width: 640px) {
  .typo__h1,
  h1 {
    font-size: 2.5rem;
  }
}
@media only screen and (min-width: 1024px) {
  .typo__h1 {
    font-size: 2.5rem;
  }
}
.typo__h2 {
  font-family: Dosis, sans-serif;
  font-weight: 700;
  font-size: 1.625rem;
  padding-top: 1.25rem;
}
@media only screen and (min-width: 640px) {
  .typo__h2 {
    font-size: 1.8rem;
  }
}
@media only screen and (min-width: 1024px) {
  .typo__h2,
  h2 {
    font-size: 1.8rem;
  }
}
.typo__h3 {
  font-family: Dosis, sans-serif;
  font-weight: 700;
  font-size: 1.375rem;
}
@media only screen and (min-width: 640px) {
  .typo__h3 {
    font-size: 1.5rem;
  }
}
@media only screen and (min-width: 1024px) {
  .typo__h3 {
    font-size: 1.5rem;
  }
}
.typo__h4 {
  font-weight: 700;
  font-size: 1.375rem;
  margin: 0.625rem 0 0;
}
@media only screen and (min-width: 640px) {
  .typo__h4 {
    font-size: 1.25rem;
  }
}
@media only screen and (min-width: 1024px) {
  .typo__h4 {
    font-size: 1.125rem;
  }
}
.typo__p {
  margin-top: 0;
  margin-bottom: 1rem;
  line-height: 1.8;
  font-weight: 400;
  font-size: 1rem;
}
@media only screen and (min-width: 640px) {
  .typo__p {
    font-size: 1.125rem;
  }
}
@media only screen and (min-width: 1024px) {
  .typo__p {
    font-size: 1.125rem;
  }
}
.typo__blockquote {
  font-family: Dosis, sans-serif;
  font-size: 1rem;
  color: #939ea5;
  margin: 0;
  border-left: 1px solid #e8e8e8;
  padding: 0.3125rem 1.25rem;
  line-height: 1.8;
  text-align: left;
}
.typo__blockquote cite {
  font-size: 0.875rem;
  font-weight: 700;
  font-style: normal;
  margin-top: 6px;
  display: block;
  color: #374853;
}
.typo__blockquote cite:before {
  content: "\2014    ";
}
.typo__hr {
  border: none;
  border-bottom: 1px solid #e8e8e8;
  margin: 1.875rem 0;
  outline: none;
}
.typo__link {
  color: #41b883;
  text-decoration: none;
  font-weight: 700;
}
.typo__label {
  font-weight: 400;
  font-size: 0.875rem;
  color: #bbb;
  margin: 1.25rem 0 0.625rem;
}
.typo__label,
.typo__text {
  display: block;
}
.typo__text {
  font-size: 1rem;
  margin: 0;
  line-height: 1.4;
}
.typo--bold,
strong {
  font-weight: 700;
}
code:not([class*="language-"]),
kbd {
  color: #41b883;
  padding: 3px 5px;
  border-radius: 4px;
  background: #f3f3f3;
  font-size: 0.9375rem;
}
pre {
  font-size: 0.875rem;
}
body,
html {
  font-size: 100%;
  height: 100%;
}
html {
  overflow-y: auto;
  box-sizing: border-box;
}
*,
:after,
:before {
  box-sizing: inherit;
}
.grid__column,
.grid__columns {
  box-sizing: border-box;
  display: inline-block;
  font-size: 1rem;
  margin: 0;
  text-align: left;
  vertical-align: top;
  width: 100%;
  position: relative;
  padding: 0 20px;
}
.grid__column--centered {
  display: block;
  margin: 0 auto;
}
.grid__row--middle .grid__column,
.grid__row--middle .grid__columns {
  vertical-align: middle;
}
.grid__row--bottom .grid__column,
.grid__row--bottom .grid__columns {
  vertical-align: bottom;
}
.grid__row {
  display: block;
  font-size: 0;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0;
  text-align: left;
  max-width: 1400px;
}
.grid__row:after,
.grid__row:before {
  content: "";
  display: table;
}
.grid__row:after {
  clear: both;
}
.grid__row .grid__row {
  margin: 0 -20px;
}
.grid__row.grid__row--collapse > .grid__column {
  padding-left: 0;
  padding-right: 0;
}
.grid__row--full {
  max-width: 100%;
}
.grid__row--centered {
  text-align: center;
}
.grid__push--small-reset {
  left: auto !important;
  right: auto !important;
}
.blocks {
  margin: 0 -10px;
}
.blocks .blocks__element {
  position: relative;
  float: left;
  box-sizing: border-box;
  transition: background 0.2s ease;
  margin: 10px;
}
.grid__unit--sm-1 {
  width: 8.33333%;
}
.grid__push--sm-1 {
  left: 8.33333%;
  right: auto;
}
.grid__pull--sm-1 {
  right: 8.33333%;
  left: auto;
}
.grid__offset--sm-1 {
  margin-left: 8.33333%;
}
.blocks--sm-1 .blocks__element {
  width: calc(100% - 20px);
}
.grid__unit--sm-2 {
  width: 16.66667%;
}
.grid__push--sm-2 {
  left: 16.66667%;
  right: auto;
}
.grid__pull--sm-2 {
  right: 16.66667%;
  left: auto;
}
.grid__offset--sm-2 {
  margin-left: 16.66667%;
}
.blocks--sm-2 .blocks__element {
  width: calc(50% - 20px);
}
.grid__unit--sm-3 {
  width: 25%;
}
.grid__push--sm-3 {
  left: 25%;
  right: auto;
}
.grid__pull--sm-3 {
  right: 25%;
  left: auto;
}
.grid__offset--sm-3 {
  margin-left: 25%;
}
.blocks--sm-3 .blocks__element {
  width: calc(33.33333% - 20px);
}
.grid__unit--sm-4 {
  width: 33.33333%;
}
.grid__push--sm-4 {
  left: 33.33333%;
  right: auto;
}
.grid__pull--sm-4 {
  right: 33.33333%;
  left: auto;
}
.grid__offset--sm-4 {
  margin-left: 33.33333%;
}
.blocks--sm-4 .blocks__element {
  width: calc(25% - 20px);
}
.grid__unit--sm-5 {
  width: 41.66667%;
}
.grid__push--sm-5 {
  left: 41.66667%;
  right: auto;
}
.grid__pull--sm-5 {
  right: 41.66667%;
  left: auto;
}
.grid__offset--sm-5 {
  margin-left: 41.66667%;
}
.blocks--sm-5 .blocks__element {
  width: calc(20% - 20px);
}
.grid__unit--sm-6 {
  width: 50%;
}
.grid__push--sm-6 {
  left: 50%;
  right: auto;
}
.grid__pull--sm-6 {
  right: 50%;
  left: auto;
}
.grid__offset--sm-6 {
  margin-left: 50%;
}
.blocks--sm-6 .blocks__element {
  width: calc(16.66667% - 20px);
}
.grid__unit--sm-7 {
  width: 58.33333%;
}
.grid__push--sm-7 {
  left: 58.33333%;
  right: auto;
}
.grid__pull--sm-7 {
  right: 58.33333%;
  left: auto;
}
.grid__offset--sm-7 {
  margin-left: 58.33333%;
}
.blocks--sm-7 .blocks__element {
  width: calc(14.28571% - 20px);
}
.grid__unit--sm-8 {
  width: 66.66667%;
}
.grid__push--sm-8 {
  left: 66.66667%;
  right: auto;
}
.grid__pull--sm-8 {
  right: 66.66667%;
  left: auto;
}
.grid__offset--sm-8 {
  margin-left: 66.66667%;
}
.blocks--sm-8 .blocks__element {
  width: calc(12.5% - 20px);
}
.grid__unit--sm-9 {
  width: 75%;
}
.grid__push--sm-9 {
  left: 75%;
  right: auto;
}
.grid__pull--sm-9 {
  right: 75%;
  left: auto;
}
.grid__offset--sm-9 {
  margin-left: 75%;
}
.blocks--sm-9 .blocks__element {
  width: calc(11.11111% - 20px);
}
.grid__unit--sm-10 {
  width: 83.33333%;
}
.grid__push--sm-10 {
  left: 83.33333%;
  right: auto;
}
.grid__pull--sm-10 {
  right: 83.33333%;
  left: auto;
}
.grid__offset--sm-10 {
  margin-left: 83.33333%;
}
.blocks--sm-10 .blocks__element {
  width: calc(10% - 20px);
}
.grid__unit--sm-11 {
  width: 91.66667%;
}
.grid__push--sm-11 {
  left: 91.66667%;
  right: auto;
}
.grid__pull--sm-11 {
  right: 91.66667%;
  left: auto;
}
.grid__offset--sm-11 {
  margin-left: 91.66667%;
}
.blocks--sm-11 .blocks__element {
  width: calc(9.09091% - 20px);
}
.grid__unit--sm-12 {
  width: 100%;
}
.grid__push--sm-12 {
  left: 100%;
  right: auto;
}
.grid__pull--sm-12 {
  right: 100%;
  left: auto;
}
.grid__offset--sm-12 {
  margin-left: 100%;
}
.blocks--sm-12 .blocks__element {
  width: calc(8.33333% - 20px);
}
@media only screen and (min-width: 640px) {
  body,
  html {
    overflow-x: initial;
  }
  .grid__push--md-reset {
    left: auto;
    right: auto;
  }
  .grid__unit--md-1 {
    width: 8.33333%;
  }
  .grid__push--md-1 {
    left: 8.33333%;
    right: auto;
  }
  .grid__pull--md-1 {
    right: 8.33333%;
    left: auto;
  }
  .grid__offset--md-1 {
    margin-left: 8.33333%;
  }
  .blocks--md-1 .blocks__element {
    width: calc(100% - 20px);
  }
  .grid__unit--md-2 {
    width: 16.66667%;
  }
  .grid__push--md-2 {
    left: 16.66667%;
    right: auto;
  }
  .grid__pull--md-2 {
    right: 16.66667%;
    left: auto;
  }
  .grid__offset--md-2 {
    margin-left: 16.66667%;
  }
  .blocks--md-2 .blocks__element {
    width: calc(50% - 20px);
  }
  .grid__unit--md-3 {
    width: 25%;
  }
  .grid__push--md-3 {
    left: 25%;
    right: auto;
  }
  .grid__pull--md-3 {
    right: 25%;
    left: auto;
  }
  .grid__offset--md-3 {
    margin-left: 25%;
  }
  .blocks--md-3 .blocks__element {
    width: calc(33.33333% - 20px);
  }
  .grid__unit--md-4 {
    width: 33.33333%;
  }
  .grid__push--md-4 {
    left: 33.33333%;
    right: auto;
  }
  .grid__pull--md-4 {
    right: 33.33333%;
    left: auto;
  }
  .grid__offset--md-4 {
    margin-left: 33.33333%;
  }
  .blocks--md-4 .blocks__element {
    width: calc(25% - 20px);
  }
  .grid__unit--md-5 {
    width: 41.66667%;
  }
  .grid__push--md-5 {
    left: 41.66667%;
    right: auto;
  }
  .grid__pull--md-5 {
    right: 41.66667%;
    left: auto;
  }
  .grid__offset--md-5 {
    margin-left: 41.66667%;
  }
  .blocks--md-5 .blocks__element {
    width: calc(20% - 20px);
  }
  .grid__unit--md-6 {
    width: 50%;
  }
  .grid__push--md-6 {
    left: 50%;
    right: auto;
  }
  .grid__pull--md-6 {
    right: 50%;
    left: auto;
  }
  .grid__offset--md-6 {
    margin-left: 50%;
  }
  .blocks--md-6 .blocks__element {
    width: calc(16.66667% - 20px);
  }
  .grid__unit--md-7 {
    width: 58.33333%;
  }
  .grid__push--md-7 {
    left: 58.33333%;
    right: auto;
  }
  .grid__pull--md-7 {
    right: 58.33333%;
    left: auto;
  }
  .grid__offset--md-7 {
    margin-left: 58.33333%;
  }
  .blocks--md-7 .blocks__element {
    width: calc(14.28571% - 20px);
  }
  .grid__unit--md-8 {
    width: 66.66667%;
  }
  .grid__push--md-8 {
    left: 66.66667%;
    right: auto;
  }
  .grid__pull--md-8 {
    right: 66.66667%;
    left: auto;
  }
  .grid__offset--md-8 {
    margin-left: 66.66667%;
  }
  .blocks--md-8 .blocks__element {
    width: calc(12.5% - 20px);
  }
  .grid__unit--md-9 {
    width: 75%;
  }
  .grid__push--md-9 {
    left: 75%;
    right: auto;
  }
  .grid__pull--md-9 {
    right: 75%;
    left: auto;
  }
  .grid__offset--md-9 {
    margin-left: 75%;
  }
  .blocks--md-9 .blocks__element {
    width: calc(11.11111% - 20px);
  }
  .grid__unit--md-10 {
    width: 83.33333%;
  }
  .grid__push--md-10 {
    left: 83.33333%;
    right: auto;
  }
  .grid__pull--md-10 {
    right: 83.33333%;
    left: auto;
  }
  .grid__offset--md-10 {
    margin-left: 83.33333%;
  }
  .blocks--md-10 .blocks__element {
    width: calc(10% - 20px);
  }
  .grid__unit--md-11 {
    width: 91.66667%;
  }
  .grid__push--md-11 {
    left: 91.66667%;
    right: auto;
  }
  .grid__pull--md-11 {
    right: 91.66667%;
    left: auto;
  }
  .grid__offset--md-11 {
    margin-left: 91.66667%;
  }
  .blocks--md-11 .blocks__element {
    width: calc(9.09091% - 20px);
  }
  .grid__unit--md-12 {
    width: 100%;
  }
  .grid__push--md-12 {
    left: 100%;
    right: auto;
  }
  .grid__pull--md-12 {
    right: 100%;
    left: auto;
  }
  .grid__offset--md-12 {
    margin-left: 100%;
  }
  .blocks--md-12 .blocks__element {
    width: calc(8.33333% - 20px);
  }
}
@media only screen and (min-width: 1024px) {
  .grid__push--lg-reset {
    left: auto;
    right: auto;
  }
  .grid__unit--lg-1 {
    width: 8.33333%;
  }
  .grid__push--lg-1 {
    left: 8.33333%;
    right: auto;
  }
  .grid__pull--lg-1 {
    right: 8.33333%;
    left: auto;
  }
  .grid__offset--lg-1 {
    margin-left: 8.33333%;
  }
  .blocks--lg-1 .blocks__element {
    width: calc(100% - 20px);
  }
  .grid__unit--lg-2 {
    width: 16.66667%;
  }
  .grid__push--lg-2 {
    left: 16.66667%;
    right: auto;
  }
  .grid__pull--lg-2 {
    right: 16.66667%;
    left: auto;
  }
  .grid__offset--lg-2 {
    margin-left: 16.66667%;
  }
  .blocks--lg-2 .blocks__element {
    width: calc(50% - 20px);
  }
  .grid__unit--lg-3 {
    width: 25%;
  }
  .grid__push--lg-3 {
    left: 25%;
    right: auto;
  }
  .grid__pull--lg-3 {
    right: 25%;
    left: auto;
  }
  .grid__offset--lg-3 {
    margin-left: 25%;
  }
  .blocks--lg-3 .blocks__element {
    width: calc(33.33333% - 20px);
  }
  .grid__unit--lg-4 {
    width: 33.33333%;
  }
  .grid__push--lg-4 {
    left: 33.33333%;
    right: auto;
  }
  .grid__pull--lg-4 {
    right: 33.33333%;
    left: auto;
  }
  .grid__offset--lg-4 {
    margin-left: 33.33333%;
  }
  .blocks--lg-4 .blocks__element {
    width: calc(25% - 20px);
  }
  .grid__unit--lg-5 {
    width: 41.66667%;
  }
  .grid__push--lg-5 {
    left: 41.66667%;
    right: auto;
  }
  .grid__pull--lg-5 {
    right: 41.66667%;
    left: auto;
  }
  .grid__offset--lg-5 {
    margin-left: 41.66667%;
  }
  .blocks--lg-5 .blocks__element {
    width: calc(20% - 20px);
  }
  .grid__unit--lg-6 {
    width: 50%;
  }
  .grid__push--lg-6 {
    left: 50%;
    right: auto;
  }
  .grid__pull--lg-6 {
    right: 50%;
    left: auto;
  }
  .grid__offset--lg-6 {
    margin-left: 50%;
  }
  .blocks--lg-6 .blocks__element {
    width: calc(16.66667% - 20px);
  }
  .grid__unit--lg-7 {
    width: 58.33333%;
  }
  .grid__push--lg-7 {
    left: 58.33333%;
    right: auto;
  }
  .grid__pull--lg-7 {
    right: 58.33333%;
    left: auto;
  }
  .grid__offset--lg-7 {
    margin-left: 58.33333%;
  }
  .blocks--lg-7 .blocks__element {
    width: calc(14.28571% - 20px);
  }
  .grid__unit--lg-8 {
    width: 66.66667%;
  }
  .grid__push--lg-8 {
    left: 66.66667%;
    right: auto;
  }
  .grid__pull--lg-8 {
    right: 66.66667%;
    left: auto;
  }
  .grid__offset--lg-8 {
    margin-left: 66.66667%;
  }
  .blocks--lg-8 .blocks__element {
    width: calc(12.5% - 20px);
  }
  .grid__unit--lg-9 {
    width: 75%;
  }
  .grid__push--lg-9 {
    left: 75%;
    right: auto;
  }
  .grid__pull--lg-9 {
    right: 75%;
    left: auto;
  }
  .grid__offset--lg-9 {
    margin-left: 75%;
  }
  .blocks--lg-9 .blocks__element {
    width: calc(11.11111% - 20px);
  }
  .grid__unit--lg-10 {
    width: 83.33333%;
  }
  .grid__push--lg-10 {
    left: 83.33333%;
    right: auto;
  }
  .grid__pull--lg-10 {
    right: 83.33333%;
    left: auto;
  }
  .grid__offset--lg-10 {
    margin-left: 83.33333%;
  }
  .blocks--lg-10 .blocks__element {
    width: calc(10% - 20px);
  }
  .grid__unit--lg-11 {
    width: 91.66667%;
  }
  .grid__push--lg-11 {
    left: 91.66667%;
    right: auto;
  }
  .grid__pull--lg-11 {
    right: 91.66667%;
    left: auto;
  }
  .grid__offset--lg-11 {
    margin-left: 91.66667%;
  }
  .blocks--lg-11 .blocks__element {
    width: calc(9.09091% - 20px);
  }
  .grid__unit--lg-12 {
    width: 100%;
  }
  .grid__push--lg-12 {
    left: 100%;
    right: auto;
  }
  .grid__pull--lg-12 {
    right: 100%;
    left: auto;
  }
  .grid__offset--lg-12 {
    margin-left: 100%;
  }
  .blocks--lg-12 .blocks__element {
    width: calc(8.33333% - 20px);
  }
}
/*.table{font-size:1rem;font-weight:400;margin-bottom:2.5rem;line-height:1.4}
.table__tr{border-bottom:1px solid #e6e6e6;box-sizing:border-box;border-left:.25rem solid transparent}
.table__tr:nth-child(2n){background:#fafafa}.table__tr:hover{background:#f4f4f4}
.table__tr--primary{border-left:.25rem solid #41b883}
.table__tr--primary:hover{background:#f3fbf7}.table__td,
.table__th{padding:.875rem 1rem}.table__th{border-bottom:1px solid #ccc}
.table__container{overflow-x:auto}
.table--full-size{width:100%}
.table--fixed{table-layout:fixed}.button{font-size:.875rem;font-weight:400;color:#fff;min-height:2.5rem;line-height:1.4;

padding:.5rem 1.875rem .625rem;box-sizing:border-box;position:relative;display:inline-block;background:#41b883;border:none;border-radius:5px;z-index:1;overflow:hidden;outline:none;vertical-align:middle;transition:background .1s ease,border-color .1s ease,color .1s ease;border-bottom:3px solid #266d4d;text-decoration:none}

*/
.badge__img:focus,
.button:hover {
  background: #349268;
  cursor: pointer;
}
.button:active {
  background: #266d4d;
}
.button:focus {
  outline: none;
}
.button--small {
  padding: 0.375rem 1.25rem;
  font-size: 0.75rem;
  min-height: 1.875rem;
}
.button--xlarge {
  padding: 0.875rem 3.125rem 0.9375rem;
  font-size: 1.125rem;
  min-height: 3.75rem;
}
.button--large {
  padding: 0.6875rem 2.5rem 0.8125rem;
  font-size: 1rem;
  min-height: 3.125rem;
}
.button--fake {
  background: none;
  color: #374853;
  border-color: transparent;
}
.button--fake:focus,
.button--fake:hover {
  background: rgba(0, 0, 0, 0.05);
}
.button--hollow {
  background: none;
  color: #374853;
  border: 1px solid #a8a8a8;
}
.button--hollow:focus,
.button--hollow:hover {
  background: rgba(0, 0, 0, 0.05);
  color: #000;
  border: 1px solid #1c1c1c;
  cursor: pointer;
}
.button--expanded {
  width: 100%;
}
.button--secondary {
  background: #374853;
  border-bottom: 3px solid #0e1316;
}
.button--secondary:focus,
.button--secondary:hover {
  background: #232d34;
  cursor: pointer;
}
.button--success {
  background: #43ac6a;
  border-bottom: 3px solid #26633d;
}
.button--success:focus,
.button--success:hover {
  background: #358753;
  cursor: pointer;
}
.button--error {
  background: #f08a24;
  border-bottom: 3px solid #a3570b;
}
.button--error:focus,
.button--error:hover {
  background: #d3710e;
  cursor: pointer;
}
.button--info {
  background: #5fadd6;
  border-bottom: 3px solid #2a7ba5;
}
.button--info:focus,
.button--info:hover {
  background: #3698cc;
  cursor: pointer;
}
.button__group {
  margin-bottom: 20px;
  width: 100%;
}
.button__group .button {
  display: inline-block;
  margin-right: 0;
  margin-bottom: 0;
  border-radius: 0;
}
.button__group .button:first-child {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.button__group .button:last-child {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.button__group--1 .button {
  width: 100%;
}
.button__group--2 .button {
  width: 50%;
}
.button__group--3 .button {
  width: 33.33333%;
}
.form {
  position: relative;
}
.form__input,
.form__textarea {
  margin-bottom: 2rem;
  font-size: 0.875rem;
  font-weight: 400;
  color: #374853;
  line-height: 2.375rem;
  min-height: 2.375rem;
  position: relative;
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  background: #fff;
  padding: 0 0.8125rem;
  width: 100%;
  transition: border 0.1s ease;
  box-sizing: border-box;
}
.form__input:hover,
.form__textarea:hover {
  border-color: #cfcfcf;
}
.form__input:focus,
.form__textarea:focus {
  border-color: #a8a8a8;
  outline: none;
}
.form__input--with-left-icon,
.form__textarea--with-left-icon {
  padding-left: 2.8125rem;
}
.form__input--with-right-icon,
.form__textarea--with-right-icon {
  padding-right: 2.8125rem;
}
.form__icon {
  position: absolute;
  pointer-events: none;
  top: -1px;
  height: 2.5rem;
  line-height: 2.5rem;
}
.form__icon--right {
  right: 0.9375rem;
}
.form__icon--left {
  left: 0.8125rem;
}
.form__textarea {
  max-width: 100%;
  min-height: 5.125rem;
  resize: none;
  line-height: 1.4;
  padding-top: 10px;
}
.form__label,
.form__label--inline {
  font-size: 0.8125rem;
  color: #4b6372;
  margin-bottom: 0.3125rem;
  margin-left: 0.875rem;
  display: block;
}
.form__label--inline {
  display: inline-block;
  margin-right: 1.25rem;
  margin-left: 0.5rem;
}
.form-group {
  margin-bottom: 2rem;
}
.form-group .form__input,
.form-group .form__textarea {
  margin-bottom: 0;
}
.form-group--merged {
  font-size: 0;
  display: table;
  width: 100%;
  border-collapse: separate;
}
.form-group--merged .form__label,
.form-group--merged .form__label--inline {
  display: table-caption;
}
.form-group__addon,
.form-group__button,
.form-group__input {
  display: table-cell;
  vertical-align: middle;
  margin: 0;
  white-space: nowrap;
}
.form-group__addon:first-child,
.form-group__button:first-child .button,
.form-group__input:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  margin-right: -1px;
}
.form-group__addon:last-child,
.form-group__button:last-child .button,
.form-group__input:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  margin-left: -1px;
}
.form-group__addon:not(:first-child):not(:last-child),
.form-group__button:not(:first-child):not(:last-child) .button,
.form-group__input:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.form-group__button:not(:first-child):not(:last-child) .button {
  margin-left: -1px;
  margin-right: -1px;
}
.form-group__addon:first-child {
  border-right: none;
}
.form-group__addon:last-child {
  border-left: none;
}
.form-group__addon {
  background: #f3f3f3;
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  height: 2.375rem;
  line-height: 2.375rem;
  width: 1%;
  padding: 0 13px;
  font-size: 14px;
  text-align: center;
}
.form-group__button {
  width: 1%;
}
.form-group__button .button {
  margin: 0;
  padding-right: 1.25rem;
  padding-left: 1.25rem;
}
.form-group__message {
  font-size: 0.75rem;
  line-height: 1;
  display: none;
  margin-left: 14px;
  margin-top: -1.6875rem;
  margin-bottom: 0.9375rem;
}
.form-group--alert,
.form-group--error {
  animation-name: b;
  animation-fill-mode: forward;
  animation-duration: 0.6s;
  animation-timing-function: ease-in-out;
}
.form-group--success .form__label,
.form-group--success .form__label--inline {
  color: #43ac6a;
}
.form-group--success .form-group__addon {
  color: #fff;
  border-color: #85d0a1;
  background: #85d0a1;
}
.form-group--success input,
.form-group--success input:focus,
.form-group--success input:hover,
.form-group--success textarea {
  border-color: #85d0a1;
}
.form-group--success + .form-group__message {
  display: block;
  color: #73c893;
}
.form-group--error .form__label,
.form-group--error .form__label--inline {
  color: #f04124;
}
.form-group--error .form-group__addon {
  color: #fff;
  border-color: #f79483;
  background: #f79483;
}
.form-group--error input,
.form-group--error input:focus,
.form-group--error input:hover,
.form-group--error textarea {
  border-color: #f79483;
}
.form-group--error + .form-group__message {
  display: block;
  color: #f57f6c;
}
.form-group--alert .form__label,
.form-group--alert .form__label--inline {
  color: #f08a24;
}
.form-group--alert .form-group__addon {
  color: #fff;
  border-color: #f7bd83;
  background: #f7bd83;
}
.form-group--alert input,
.form-group--alert input:focus,
.form-group--alert input:hover,
.form-group--alert textarea {
  border-color: #f7bd83;
}
.form-group--alert + .form-group__message {
  display: block;
  color: #f5b06c;
}
@keyframes b {
  0% {
    transform: translateX(0);
  }
  15% {
    transform: translateX(0.375rem);
  }
  30% {
    transform: translateX(-0.375rem);
  }
  45% {
    transform: translateX(0.375rem);
  }
  60% {
    transform: translateX(-0.375rem);
  }
  75% {
    transform: translateX(0.375rem);
  }
  90% {
    transform: translateX(-0.375rem);
  }
  to {
    transform: translateX(0);
  }
}
.list {
  font-size: 1rem;
  color: #374853;
  letter-spacing: 0.4px;
  line-height: 32px;
  list-style: none;
}
.list--sticky {
  position: fixed;
  top: 0;
  width: calc(25% - 40px);
  max-width: 19.375rem;
  overflow: auto;
  height: calc(100% - 1em);
}
.list__heading {
  font-family: Dosis, sans-serif;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.875rem;
  color: #41b883;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin: 1.25rem 0 0;
}
.list__link {
  color: #374853;
  text-decoration: none;
  display: block;
  padding: 0.4375rem 0.625rem;
  margin-left: -0.625rem;
  border-radius: 5px;
  line-height: 1.3;
}
.list__link--active {
  background: #f3f3f3;
}
.list__link--disabled {
  color: #939ea5;
  pointer-events: none;
}
.list__desc {
  display: block;
  font-size: 0.875rem;
  color: #939ea5;
  line-height: 1.4;
  max-width: 200px;
  margin-top: 3px;
}
.list__img {
  display: inline-block;
  vertical-align: sub;
  margin-left: 5px;
}
.list__dl {
  font-weight: 400;
}
.list__dt {
  font-size: 0.875rem;
  margin-bottom: 0.625rem;
  color: #bbb;
}
.list__dd {
  font-size: 1rem;
  margin-left: 0;
  margin-bottom: 1.25rem;
  line-height: 1.4;
}
.list__ol,
.list__ul {
  margin: 0 0 0 1.875rem;
  padding: 0;
  line-height: 1.8;
  font-weight: 400;
}
.list__ul {
  list-style: square;
}
.tabs {
  display: flex;
  align-items: stretch;
  min-height: 2.5rem;
}
.tabs__link {
  display: block;
  padding: 0 1.25rem;
  font-size: 1rem;
  font-weight: 400;
  text-decoration: none;
  cursor: pointer;
  line-height: 2.5rem;
  color: #939ea5;
  transition: color 0.2s ease;
}
.tabs__link--active {
  font-weight: 700;
  color: #374853;
}
.tabs {
  flex-direction: row;
}
.tabs,
.tabs__link {
  border-bottom: 3px solid #e8e8e8;
}
.tabs__link {
  margin-bottom: -3px;
}
.tabs__link:focus,
.tabs__link:hover {
  color: #374853;
}
.tabs__link--active {
  border-color: #41b883;
}
@media only screen and (max-width: 640px) {
  .small--hidden {
    display: none !important;
  }
}
@media only screen and (min-width: 640px) and (max-width: 1024px) {
  .medium--hidden {
    display: none !important;
  }
}
@media only screen and (min-width: 640px) {
  .medium-up--hidden {
    display: none !important;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1440px) {
  .large--hidden {
    display: none !important;
  }
}
@media only screen and (min-width: 1024px) {
  .large-up--hidden {
    display: none !important;
  }
}
@media only screen and (min-width: 1440px) and (max-width: 1920px) {
  .xlarge--hidden {
    display: none !important;
  }
}
.utils--center {
  text-align: center;
}
.utils--right {
  text-align: right;
}
code[class*="language-"],
pre[class*="language-"] {
  color: #000;
  text-shadow: 0 1px #fff;
  font-family: Consolas, Monaco, Andale Mono, Ubuntu Mono, monospace;
  direction: ltr;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  line-height: 1.5;
  -moz-tab-size: 4;
  -o-tab-size: 4;
  tab-size: 4;
  -webkit-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;
}
code[class*="language-"]::-moz-selection,
code[class*="language-"] ::-moz-selection,
pre[class*="language-"]::-moz-selection,
pre[class*="language-"] ::-moz-selection {
  text-shadow: none;
  background: #b3d4fc;
}
code[class*="language-"]::selection,
code[class*="language-"] ::selection,
pre[class*="language-"]::selection,
pre[class*="language-"] ::selection {
  text-shadow: none;
  background: #b3d4fc;
}
@media print {
  code[class*="language-"],
  pre[class*="language-"] {
    text-shadow: none;
  }
}
pre[class*="language-"] {
  padding: 1.3em 1em;
  margin: 0 0 20px;
  overflow: auto;
}
:not(pre) > code[class*="language-"],
pre[class*="language-"] {
  background: #f3f5f6;
}
:not(pre) > code[class*="language-"] {
  padding: 0.1em;
  border-radius: 0.3em;
  white-space: normal;
}
.token.cdata,
.token.comment,
.token.doctype,
.token.prolog {
  color: #708090;
}
.token.punctuation {
  color: #999;
}
.namespace {
  opacity: 0.7;
}
.token.boolean,
.token.constant,
.token.deleted,
.token.number,
.token.property,
.token.symbol,
.token.tag {
  color: #905;
}
.token.attr-name,
.token.builtin,
.token.char,
.token.inserted,
.token.selector,
.token.string {
  color: #690;
}
.language-css .token.string,
.style .token.string,
.token.entity,
.token.operator,
.token.url {
  color: #a67f59;
  background: hsla(0, 0%, 100%, 0.5);
}
.token.atrule,
.token.attr-value,
.token.keyword {
  color: #07a;
}
.token.function {
  color: #dd4a68;
}
.token.important,
.token.regex,
.token.variable {
  color: #e90;
}
.token.bold,
.token.important {
  font-weight: 700;
}
.token.italic {
  font-style: italic;
}
.token.entity {
  cursor: help;
}
div.prism-show-language {
  position: relative;
}
div.prism-show-language > div.prism-show-language-label[data-language] {
  color: #000;
  background-color: #cfcfcf;
  opacity: 0.5;
  display: inline-block;
  position: absolute;
  bottom: auto;
  left: auto;
  top: 0;
  right: 0;
  width: auto;
  height: auto;
  font-size: 0.9em;
  border-radius: 0 0 0 5px;
  padding: 0.1em 0.5em;
  text-shadow: none;
  z-index: 1;
  box-shadow: none;
  transform: none;
}
.invalid .typo__label {
  color: #f04124;
}
.invalid .multiselect__tags {
  border-color: #f04124 !important;
}
body {
  color: #35495e;
  font-family: Lato, Helvetica, sans-serif;
  text-decoration: none;
}
.start {
  text-align: center;
  display: block;
  background: linear-gradient(to left bottom, #8cc1f7 0, #9cffd3);
}
.start .typo__h1 {
  padding-top: 2.5rem;
  position: relative;
}
.start .typo__h3 {
  padding: 1.25rem 0 0;
}
@media only screen and (min-width: 640px) {
  .start {
    min-height: 100vh;
  }
}
.start .button {
  margin-bottom: 1.5rem;
}
.docs,
.start__list {
  padding-top: 1.875rem;
}
.docs {
  text-align: left;
}
.center-vertically {
  position: relative;
}
@media only screen and (min-width: 640px) {
  .center-vertically {
    position: absolute;
    height: 600px;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
.multiselect-example__container {
  margin: 0 auto 60px;
}
.button {
  margin: 0 0.625rem;
}
.logo {
  height: 4.375rem;
  margin-right: 1.25rem;
  vertical-align: middle;
  display: inline-block;
}
.button--github {
  padding-left: 3.75rem;
}
.button--github:before {
  content: url(data:image/svg+xml;base64,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);
  left: 1.5625rem;
  position: absolute;
}
.blank__link {
  color: inherit;
  text-decoration: none;
}
.version {
  position: absolute;
  bottom: -0.4375rem;
  font-size: 1.25rem;
  color: #374853;
  transform: translateX(-100%);
}
.badges {
  margin-bottom: 15px;
}
.badges img {
  margin: 0 2px;
}
.list__multiselect {
  line-height: 1.4;
}
section {
  margin-bottom: 1.25rem;
}
#examples .grid__column > p > a {
  font-weight: 700;
  color: #41b883;
  text-decoration: none;
}
#examples .grid__column > ul {
  padding-left: 1.5625rem;
  margin-top: 0.4375rem;
}
#examples .grid__column > ul li {
  line-height: 1.8;
  font-weight: 400;
  font-size: 1rem;
  padding: 0.25rem 0;
}
</style>
